import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";

require("../utils/Paths")

i18next
.use(HttpApi)
.use(initReactI18next)
.init({
    debug: false,
    interpolation: {
        escapeValue: false,
    },
    // resources,
    fallbackLng: "en",
    backend: {
        loadPath: window.Paths.TRANSLATIONS + '{{lng}}/{{lng}}.json'
    }
});

export default i18next;
